module.exports = __webpack_public_path__ + "static/media/dead.9bc76cfb.png";